import axiosInstance from '../services/axiosInstance';
import { envUrls, buildEnvironment } from './env';

// Uncomment this to test localhost
//envUrls.authService = 'http://localhost:4067/';

export default class BasicAuthService {
  static async login(payload) {
    /** {
          "email": "",
          "password": ""
        }
    */
    return axiosInstance
      .post(`${envUrls.authService}auth/basic/login`, payload)
      .then((response) => response.data);
  }

  static async register(payload) {
    /** {
          "name": "Jane Doe",
          "username": "jane.doe@mail.mil",
          "email": "jane.doe@mail.mil",
          "password": "",
          "organization_type": "Government",
          "organization": "USAF AFRL",
          "phone": "555-555-5555"
        }
    */
    if (buildEnvironment === 'staging') {
      // This is running on the STAGING site -- add stagingSite flag to payload
      payload.stagingSite = true;
    }

    return axiosInstance
      .post(`${envUrls.authService}auth/basic/register`, payload)
      .then((response) => response.data);
  }

  static async createPublicSession() {
    return axiosInstance
      .post(`${envUrls.authService}auth/basic/public/session`)
      .then((response) => response.data);
  }

  static async forgotPassword(payload) {
    /** {
          "email": "jane.doe@mail.mil",
        }
    */
    if (buildEnvironment === 'staging') {
      // This is running on the STAGING site -- add stagingSite flag to payload
      payload.stagingSite = true;
    }
    return axiosInstance
      .post(`${envUrls.authService}auth/basic/send/password/reset`, payload)
      .then((response) => response.data);
  }

  static async resetPassword(payload) {
    // payload must include { token, password }
    return axiosInstance
      .post(`${envUrls.authService}auth/basic/reset/password`, payload)
      .then((response) => response.data);
  }

  static async verifyInvite(token) {
    return axiosInstance
      .get(`${envUrls.authService}auth/basic/invite/verify`, { params: { token } })
      .then((response) => response.data);
  }

  static async acceptInvite(payload) {
    // payload: { token, password }
    return axiosInstance
      .post(`${envUrls.authService}auth/basic/invite/accept`, payload)
      .then((response) => response.data);
  }
}
